export default {
  setFoodVouchers(state, payload) {
    state.foodVouchers = payload;
  },
  setFoodVoucherReviews(state, payload) {
    state.foodVoucherReviews = payload;
  },
};
